import { render, staticRenderFns } from "./LcPage.vue?vue&type=template&id=4359e055&scoped=true"
import script from "./LcPage.vue?vue&type=script&lang=js"
export * from "./LcPage.vue?vue&type=script&lang=js"
import style0 from "./LcPage.vue?vue&type=style&index=0&id=4359e055&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4359e055",
  null
  
)

export default component.exports